/** 오프라인 시 Supabase 등 네트워크 호출 차단 */

export function isAppOnline() {
  return typeof navigator === 'undefined' ? true : navigator.onLine;
}

export function assertOnlineOrThrow() {
  if (!isAppOnline()) {
    const e = new Error('OFFLINE');
    e.code = 'OFFLINE';
    throw e;
  }
}
